import React from 'react';
import { arrivalLineColor, closureLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmArrivalClosureChart(props) {
  const { arrival, closure, increment, d0_interval, d2_interval } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Arrival / Closure Prediction'
      arrival={arrival}
      closure={closure}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      arrivalColor={arrivalLineColor}
      closureColor={closureLineColor}
      chartHeight='30vw'
      showArrival={true}
      showClosure={true}
    />
  );
}
